module.exports = __webpack_public_path__ + "static/media/tshirt-solid.42c3ac34.svg";